import * as React from 'react';
export const QASvg = React.forwardRef(function QASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4v1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4v1H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        d: 'M14.003 14H5l1-.5-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1L5 2h9.003C15.104 2 16 2.9 16 4.009v7.982A2.005 2.005 0 0 1 14.003 14Z',
      }),
    ),
  );
});
QASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var QA = {
  category: 'flag',
  colorable: false,
  name: 'QA',
  svg: QASvg,
};
